import React from "react";
import {
  Box,
  Typography,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  AccordionDetails,
  useTheme,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";

const Accordion = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxShadow: "none",
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  flexDirection: "row-reverse",
  [`& .MuiAccordionSummary-expandIconWrapper`]: {
    color: theme.palette.primary.main,
    size: "10px",
  },
  [`& .MuiAccordionSummary-expandIconWrapper.Mui-expanded`]: {
    transform: "rotate(45deg)",
  },
  [`& .MuiAccordionSummary-content`]: {
    marginLeft: theme.spacing(1),
  },
}));

const faqs = [
  {
    question: "Purchase info",
    answer:
      "At this time, we only take cashier’s checks, with a 14-day waiting period prior to shipping in order to ensure everybody’s protection! Since we are also a non-profit, your purchase may be eligible for tax incentives!",
  },
  {
    question: "Liability release",
    answer: "No liability here...",
  },
  {
    question: "Delivery options",
    answer: "Cranes are cool!",
  },
];

export default function FAQ() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flexDirection: "column",
        backgroundColor: "background.default",
        px: 10,
        py: 4,
      }}
    >
      <Stack direction="row" spacing={2}>
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.primary.main,
            pb: 3,
            fontWeight: "bold",
          }}
        >
          Things to know
        </Typography>
      </Stack>
      {faqs.map((faq, index) => (
        <Accordion key={index} disableGutters square>
          <AccordionSummary
            expandIcon={
              <AddIcon
                sx={{
                  fontSize: 20,
                  color: theme.palette.primary.main,
                }}
              />
            }
            aria-controls={`panel${index}a-content`}
            id={`panel${index}a-header`}
          >
            <Typography
              variant="body1"
              sx={{ fontWeight: "bold", color: theme.palette.text.primary }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.text.primary }}
            >
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
